import type { InternalLinkingGc } from '@web-platform/shared-universal-types/src/apis/context/seoComponents';
import type { Nullable } from '@web-platform/shared-universal-types-utils/src/utils';

let internalLinkingGcData: Nullable<InternalLinkingGc>;

const setInternalLinkingGcData = (newInternalLinkingGcData: InternalLinkingGc): void => {
  internalLinkingGcData = newInternalLinkingGcData;
};

const getInternalLinkingGcData = (): Nullable<InternalLinkingGc> => internalLinkingGcData;

export { getInternalLinkingGcData, setInternalLinkingGcData };
